import React from 'react';

const Section$ = () => <div style={{textIndent: '2em'}}>
    <div style={{textAlign: 'center'}}>
        <br/>
        <h1 name="0-7" className="point" id="0-7">第八章 技术管理制度</h1></div>
    <div style={{textIndent: '2em'}}>
        <br/>
        <h2 name="0-7-0" className="point" id="0-7-0">一、技术资料/档案管理细则</h2>
        <h3 name="0-7-0-0" className="point" id="0-7-0-0">1、总则</h3>
        <p>1、为建立、健全公司技术档案工作，完整地保存和科学地管理公司的技术档案，充分发挥技术档案在公司建设和发展中的作用，更好地为公司各生产技术部门服务。特制订本管理制度。</p>
        <p>2、本公司技术档案是指各技术部门（包括车间）在生产技术、科研成果、质量、设备、基建等技术活动中形成的应当归档保存的图纸、图表、文字材料、照片等技术资料以及外来、外购的图纸、资料、图书等。</p>
        <p>3、公司技术职能部门、车间要把技术档案工作纳入本单位的技术业务管理工作中，保证其技术文件材料的积累，达到收集齐全、整理系统，并按制度及时归档。以保证全公司技术档案工作的顺利开展。</p>
        <p>4、按照集中统一管理技术档案的基本原则，公司技术应用管理中心设立技术信息部，集中统一管理全公司的生产、开发、质量、设备、基建等技术档案。建立、健全技术档案工作，达到全公司技术档案的完整、准确、系统、安全和有效利用。</p>

        <h3 name="0-7-0-1" className="point" id="0-7-0-1">2、技术文件的归档</h3>
        <p>1、每一个技术项目完成或告一段落后，都要有完整、准确、系统的技术文件资料，并按公司形成技术文件资料的归档范围和要求，将所形成的技术文件资料加以系统的整理，组成保管单位（卷、代、册、盒），由技术信息部负责人审查后及时移交归档。</p>
        <p>2、各部门或技术人员在移交技术档案或技术文件资料时，交接双方应按规定办理交接手续，签字归档备查。凡不符合组卷要求或技术文件资料不全的，技术信息部负责人有权拒绝接收。</p>
        <p>3、凡需归档的技术文件资料，应尽量符合国家标准、行业标准和企业标准的规定。做到书写材料优良，字迹工整，图纸按规格绘制，图样清晰。严禁用铅笔、圆珠笔和复写纸打印。</p>
        <p>4、凡各部门形成的图纸类文件，应描制底图一份，并经技术负责人签字后，向技术应用管理中心移交归档。</p>
        <p>5、凡外来、外购回公司的图纸资料，随仪器、设备入厂的图纸、使用说明书、电气线路图等在开封前，有关部门必须通知技术应用管理中心人员参加清点，如数归档。在未办理借阅使用手续前任何人不得据为私有或拿走。</p>
        <p>6、各主机厂家组织市场最新技术培训，对参加培训人员有如下要求：</p>
        <p>6.1、遵守培训会议纪律，认真完成培训课程，获得结业证书(如果有)或通过考试测评。</p>          <p>6.2、将培训资料完整带回，交技术应用管理中心存档。</p>
        <p>6.3、回到工作岗位后三天内，在云豪职业智慧学院进行组织公司内部转训。</p>
        <p>6.4、指派的参训人员应工作稳定，不得随意离职或更换工作岗位。</p>
        <p>6.5、与培训课程的所有授课讲师建立良好的工作联系。</p>
        <p>6.6、赴外省市参加的培训课程，在结束培训后，差旅费报销凭证需技术应用管理中心负责人签字审核，以确认是否完成上述要求，每项要求积分100/次奖励或扣除。</p>
        <p>7、要求各部门技术负责人每周至少提交一篇特殊故障案例素材，技术应用管理中心负责软文整理、编辑发表，完善技术资料数据库，积分100/次奖励或扣除。</p>

        <h3 name="0-7-0-2" className="point" id="0-7-0-2">3、技术中心的任务和管理人员的职责</h3>
        <h4>1、技术中心的任务</h4>
        <p>1.1、集中、统一、科学地管理好技术档案，维护技术档案的完整、系统、准确和安全，并及时、准确地提供利用。因工作严重失职，造成技术档案原件遗失、缺漏、污损破坏至无法使用、借出无法收回等，技术信息部管理人员应负主要责任，积分200/次扣除。</p>
        <p>1.2、协助各部门和有关技术人员做好技术文件资料的形成积累和正确地整理、立卷归档工作。</p>
        <p>1.3、承担技术文件资料的接收、复制、借阅、发放和建档，提供技术资料为全公司有关单位和技术人员服务。</p>
        <h4>2、技术中心管理人员的职责</h4>
        <p>2.1、认真贯彻公司技术档案工作的方针政策。钻研业务，提高管理水平，保证技术档案工作任务的完成。积极主动地为生产、开发提供技术资料。</p>
        <p>2.2、科学地管理全公司技术档案，承办技术资料和技术档案的接收、分类、编目、登记、保管、复制、借阅、发放、鉴定、统计以及绘制检索工具等工作。</p>
        <p>2.3、遵守公司保密制度，做好安全保卫工作。</p>
        <p>2.4、严格执行技术档案的保管、借阅、发放制度。</p>
        <p>2.5、保持档案室内整洁、卫生，对破损或变质的档案，要及时修补和提出复制。</p>

        <h3 name="0-7-0-3" className="point" id="0-7-0-3">4、档案保管和借阅</h3>
        <p>1、对接收来的技术档案进行分类、编目、登记、统计和必要的加工管理，编制《档案查阅目录》，做到定位存放，妥善保管，方便利用。</p>
        <p>2、认真执行技术档案的保管检查制度，每年年底全面检查、清理一次，做到帐档一致。并于12月30日以前整理出检查报告，交技术应用管理中心审查，根据检查报告的结果，对出现的问题进行整改，并对检查报告的真实性进行复查。</p>
        <p>3、做好技术档案的安全、保密工作，并履行批准和借阅手续。经常保持室内清洁通风，注意防尘、防火、防水、防潮、防晒和防盗。防止档案被虫蛀、鼠咬、霉烂等。如有破损或变质的档案，技术信息部管理人员要及时修补和提出复制。</p>
        <p>4、技术档案的保密制度：</p>
        <p>4.1、全公司职工必须严守机密，维护技术档案的安全。凡借阅重要的档案（包括外来、外购的资料，随仪器、设备回公司的文件资料，原始底图等），要由技术应用管理中心批准后方可借阅。借阅者必须妥善保管，不得遗失。</p>
        <p>4.2、技术档案如有丢失、被盗、泄密等情况，应立即上报并采取措施作妥善处理。</p>
        <p>4.3、非工作人员未经允许，不得随意翻阅技术档案。</p>
        <p>5、技术档案的借阅</p>
        <p>5.1、凡本公司技术人员、工作人员，因生产需要都可借阅技术档案。由管理人员填写《文件借阅登记表》，借阅人员签字后，方可使用。用后按期归还，经技术信息部管理人员检查后，方可办理注销手续。</p>
        <p>5.2、技术档案和各种设备说明书等，均在公司内控制使用，档案原件不得借出档案室，仅供在室内查阅。若需借出室，应办理手续，借出副本。如无副本时，需经技术应用管理中心批准方能借出。</p>
        <p>5.3、经同意借出之档案，每次最长时间为三天。如工作需要，到期后需继续使用的，应办理续借手续。如遇假期，必须将所借技术档案退回。到期未归还或未办理续借手续者，由技术信息部管理员负责催收，并要求其限期归还。到期还未归还，由档案管理员根据所借资料的实际价值（各类书籍按标价、资料按制作价格）报技术应用管理中心审查，总经理批准后，对档案借阅人进行积分200/次扣除。事后借阅者如能归还所借档案，根据其时间的长短，可按积分50/次扣除。</p>
        <p>5.4、借阅者应保持档案的完整、安全、整洁，不得转借、拆散、涂改、抽换和丢失。借、还双方应共同清点份数、页数，并检查完整情况，做到认真负责。如发现问题或有损坏者，及时向技术应用管理中心汇报。并根据其完整或损坏的程度及档案的重要性由技术信息部管理员报技术应用管理中心审查进行积分50/次扣除。</p>

        <h3 name="0-7-0-4" className="point" id="0-7-0-4">5、档案复制和资料的发放</h3>
        <p>1、凡归档的技术文件资料，一般应存档一份。重要的和使用频繁的应复制备份一份，供日常借阅或发放使用，备份文件发放后，应及时复制补充完整。</p>
        <p>2、需加工制作的工装类图纸文件，应复制三套。一套用于技术员作工艺后发放采购部备料，以及转交质量部进行木模、坯料检查，其中装配图发放于模具保管，供工装的管理使用；一套发放生产部或采购部，用于加工订货；一套用于档案室存档，供日常借阅使用。</p>
        <p>3、用作指导生产的工艺卡片、工序卡片、生产作业指导书等，应复制三份，发放生产车间、分管技术员及档案室存档。</p>
        <p>4、作为验收依据的检验卡片，应复制三份，发放质量部、分管技术员及技术应用管理中心存档。</p>

        <h2 name="0-7-1" className="point" id="0-7-1">二、设计和开发管理流程</h2>
        <h4>一、目的</h4>
        <p>明确设计和开发过程的主要工作和内容，对设计和开发全过程进行控制，确保产品设计满足有关法律法规和强制性国家标准的要求。</p>
        <h4>二、范围</h4>
        <p>适用于我厂消防车产品的设计和开发全过程的控制。</p>

        <h3 name="0-7-1-0" className="point" id="0-7-1-0">1、职责</h3>
        <p>1、总工程师负责消防车产品的开发满足国家法律、法规和国家强制性标准的要求。</p>
        <p>2、技术部负责编制设计开发计划，以及设计过程的实施。</p>
        <p>3、生产车间负责样车的试制生产。</p>
        <p>4、销售部负责提供有关消防车产品的市场需求信息。</p>
        <p>5、供应负责所需物资的采购。</p>
        <p>6、质检部负责产品的试验和检测工作。</p>

        <h3 name="0-7-1-1" className="point" id="0-7-1-1">2、工作程序</h3>
        <h4 name="0-7-1-1-0" className="point" id="0-7-1-1-0">2.1设计和开发项目提出</h4>
        <p>1.1、自主开发项目</p>
        <p>1.2、销售部负责进行市场调研，根据消防车产品市场动态和需求、产品特点、价格等提供必要的信息报告。</p>
        <p>1.3、技术部根据信息报告和市场动态（必要时也可进行市场调研），编制“产品开发计划”，报厂领导决策。</p>
        <p>1.4、合同开发项目：销售部将合同或标书中与产品有关的要求，提供给技术部门，技术部门负责制定“产品开发计划”，报领导决策。</p>
        <p>1.5、总工程师负责组织领导技术部、质检部、销售部、车间等相关部门进行评审，批准“产品开发计划”并形成文件。</p>
        <p>1.6、技术部根据批准后的“产品开发计划”制定 “项目实施计划”。内容包括：</p>
        <p>1.6.1、确定设计和开发阶段；</p>
        <p>1.6.2、明确各阶段任务与责任、人员、资源配置和进度安排；</p>
        <p>1.6.3、明确各阶段的评审、验证和确认活动；</p>
        <p>1.6.4、“项目实施计划”由项目负责人编制、技术部负责人审核；</p>
        <p>1.6.5、“项目实施计划”应随着设计进展适时进行调整、修改。</p>
        <p>1.6.6、技术部在设计开发过程中应及时和相关部门进行沟通。</p>
        <h4 name="0-7-1-1-1" className="point" id="0-7-1-1-1">2.2设计和开发输入</h4>
        <p>2.1、项目负责人根据“项目实施计划”编制项目“设计任务书”，内容包括：</p>
        <p>2.1.1、设计依据、设计目标和用途（包括法律法规、强制性标准要求）；</p>
        <p>2.1.2、项目应达到的技术参数和性能指标。</p>
        <p>2.1.3、主要结构的描述、关键件的选用；</p>
        <p>2.1.4、执行标准。</p>
        <p>2.1.5、市场与成本价格分析。</p>
        <p>2.2、设计和开发输入由总工程师组织有关人员进行评审。</p>
        <p>2.3、设计和开发输入经评审后，由总工程师批准实施；</p>
        <h4 name="0-7-1-1-2" className="point" id="0-7-1-1-2">2.3设计和开发输出</h4>
        <p>3.1、总体方案确定</p>
        <p>3.1.1、项目负责人依据“设计任务书”、进行总体方案设计。</p>
        <p>3.1.2、总工程师组织相关人员对总体方案进行评审。</p>
        <p>3.1.3、项目负责人依据评审报告对总体方案进行修改、完善后报总工程师审核批准后执行。</p>
        <p>3.2、设计阶段</p>
        <p>3.2.1、项目负责人根据批准的总体方案，对设计项目进行分解，提出各分项的设计要求。</p>
        <p>3.2.2、项目组其他成员根据分项设计要求，进行分项部件、总成、零件的设计工作。设计工作包括：</p>
        <p>a)、编制设计计算书</p>
        <p>b)、产品图纸设计、工艺文件；</p>
        <p>c)、外购件明细表；</p>
        <p>d)、企业标准；</p>
        <p>e)、关键件明细表；</p>
        <p>f)、使用说明书；</p>
        <p>g)、材料定额；</p>
        <p>3.2.3、项目组人员在设计工作中应相互沟通信息，避免出现差错。</p>
        <p>3.3、设计输出</p>
        <p>3.3.1、设计输出的文件应符合4.3.2.2的要求。</p>
        <p>3.3.2、设计输出文件输出前应进行评审和授权人批准。</p>

        <h4 name="0-7-1-1-3" className="point" id="0-7-1-1-3">2.4设计评审</h4>
        <p>4.1、设计输入应进行评审，评审的主要内容：</p>
        <p>4.1.1、主要技术参数和性能指标的合理性。</p>
        <p>4.1.2、关键件选用的合理性。</p>
        <p>4.1.3、主要结构正确性、先进性、合理性。</p>
        <p>4.1.4、强制性标准的符合性。</p>
        <p>4.2、总体设计方案应进行评审，评审的内容：</p>
        <p>4.2.1、总体设计结构的先进性、合理性。</p>
        <p>4.2.2、总体外形的美观性。</p>
        <p>4.2.3、强制标准和法规的符合性。</p>
        <p>4.3、设计阶段评审</p>
        <p>4.3.1、在设计适当的阶段，应进行评审。项目负责人负责项目组成员分项设计的评审。技术部主管负责对项目负责人的设计评审。项目组成员的设计可相互评审。</p>
        <p>4.3.2、设计阶段的评审内容：</p>
        <p>a)、结构的合理性、正确性。</p>
        <p>b)、材料选用的合理性、经济性、正确性。</p>
        <p>c)、计算的正确性。</p>
        <p>d)、标准的符合性。</p>

        <h4 name="0-7-1-1-4" className="point" id="0-7-1-1-4">2.5设计验证</h4>
        <p>5.1、样车试制</p>
        <p>5.1.1、技术部负责将批准后的设计输出文件下发相关部门。</p>
        <p>5.1.2、供应按照（关键件明细表）、（外购件明细表）和生产计划进行采购。</p>
        <p>5.1.3、生产车间按照生产计划和技术部门提供的产品图纸和技术文件组织样车试制。</p>
        <p>5.1.4、技术部门配合车间进行样车试制及时处理试制中出现的技术问题。</p>
        <p>5.2、整车试验验证</p>
        <p>5.2.1、质检部负责按照技术部下发的（企业标准）规定的检验试验项目实施检验验证。</p>
        <p>5.2.2、质检部根据试验结果出据验证报告、质检部负责人对验证报告进行审核后报总工程师批准。</p>
        <p>5.2.3、总工程师组织相关人员对验证报告进行评审；</p>
        <p>a)、验证报告满足设计输出要求时，可进行设计确认。</p>
        <p>b)、验证报告不能满足设计输出要求时，技术部项目负责人应制定具体的改进方案报总工程师审批。生产车间组织实施，质检部重新验证直到满足设计输出要求。</p>
        <h4 name="0-7-1-1-5" className="point" id="0-7-1-1-5">2.6设计确认、存档</h4>
        <p>6、设计确认</p>
        <p>验证合格后的样车由质检部负责提交国家消防车消防装备监督检中心进行型式检测确认。</p>
        <p>7、设计和开发过程中的记录技术部应妥善保存。执行《记录控制程序》。</p>


        <h3 name="0-7-1-2" className="point" id="0-7-1-2">3、相关文件、计划书、报告模板</h3>
        <p>BXF/QP21—2005文件和资料控制程序</p>
        <p>BXF/QP22—2005记录控制程序</p>
        <p>六、相关记录 表格</p>
        <p> “产品开发计划”</p>
        <p> “项目实施计划”</p>
        <p> “设计任务书”</p>
        <p> “设计评审报告”</p>
        <p> “设计验证报告”。</p>

        <h2 name="0-7-2" className="point" id="0-7-2">三、维护保养作业切块工艺管理规范</h2>
        <h3 name="0-7-2-0" className="point" id="0-7-2-0">1、发动机</h3>
        <h3 name="0-7-2-1" className="point" id="0-7-2-1">2、冷却系统</h3>
        <h3 name="0-7-2-2" className="point" id="0-7-2-2">3、燃油、后处理系统</h3>
        <h3 name="0-7-2-3" className="point" id="0-7-2-3">4、新能源车</h3>
        <h3 name="0-7-2-4" className="point" id="0-7-2-4">5、离合器系统</h3>
        <h3 name="0-7-2-5" className="point" id="0-7-2-5">6、变速箱</h3>
        <h3 name="0-7-2-6" className="point" id="0-7-2-6">7、传动轴总成</h3>
        <h3 name="0-7-2-7" className="point" id="0-7-2-7">8、前桥</h3>
        <h3 name="0-7-2-8" className="point" id="0-7-2-8">9、后桥</h3>
        <h3 name="0-7-2-9" className="point" id="0-7-2-9">10、制动系统</h3>
        <h3 name="0-7-2-10" className="point" id="0-7-2-10">11、悬挂系统</h3>
        <h3 name="0-7-2-11" className="point" id="0-7-2-11">12、专项系统</h3>
        <h3 name="0-7-2-12" className="point" id="0-7-2-12">13、电器系统</h3>
        <h3 name="0-7-2-13" className="point" id="0-7-2-13">14、仪表仪器</h3>
        <h3 name="0-7-2-14" className="point" id="0-7-2-14">15、驾驶操作系统</h3>
        <h3 name="0-7-2-15" className="point" id="0-7-2-15">16、底盘保养与及测</h3>

    </div>
</div>;

export default Section$;